// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60957":"6cfff3f53e02ad24","74724":"b6323009d4472833","96325":"635140f8675d1ec5"}[chunkId] + ".css";
};